import { render, staticRenderFns } from "./ReportProdTask.vue?vue&type=template&id=bf8aaf6e&scoped=true&"
import script from "./ReportProdTask.vue?vue&type=script&lang=js&"
export * from "./ReportProdTask.vue?vue&type=script&lang=js&"
import style0 from "./ReportProdTask.vue?vue&type=style&index=0&id=bf8aaf6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8aaf6e",
  null
  
)

export default component.exports